import { useContext } from "react";
import { locationContext } from "contexts/LocationContext";

export const useLocations = () => useContext(locationContext);
